module.exports = __webpack_public_path__ + "img/n3-press.cf1f284b.png";